import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { DadosDashboardGestaoAssinatura } from "types/dto/groupsign/DadosDashboardGestaoAssinatura";
import { FiltroDashboardDTO } from "types/dto/groupsign/FiltroDashboardDTO";

const useGetDadosDashboardGestaoAssinatura = (filtro: FiltroDashboardDTO) => {
  return useFetch<DadosDashboardGestaoAssinatura>({
    url: `${api.groupsign.getDadosDashboard}`,
    key: ["gestao-assinatura-digital-documento", filtro],
    params: filtro,
  });
};

export default useGetDadosDashboardGestaoAssinatura;
